export default "__VITE_ASSET__BohUg5OR__"